import { createSelector } from "reselect";

import { canUserDo } from "redux/modules/permissions/user-permission-profile/selectors";
import { eventId as getEventId } from "redux/modules/event/selectors";
import * as STANDARD_MODULE_IDS from "@sessionboard/sessionboard-value-types/src/constants/standard-modules";

export const canAssignTask = createSelector(
  state => canUserDo(state, getEventId(state)),
  canDo => canDo(`${STANDARD_MODULE_IDS.portalTasks.id}_create`)
);
